import React from 'react';
import { TouchableOpacity } from 'react-native';
import { RegularText, SizedBox } from 'src/components/bases';
import { AppColors } from 'src/themes/Colors';

export const TripLabelValue: React.FC<{
  label: string;
  value: string | React.ReactElement;
  style?: any;
  onPress?: () => void;
  labelAlign?: 'auto' | 'left' | 'right' | 'center' | 'justify' | undefined;
}> = ({ label, value, style, onPress = null, labelAlign }) => {
  return (
    <TouchableOpacity
      style={style}
      disabled={!onPress}
      activeOpacity={0.8}
      onPress={onPress !== null ? onPress : () => {}}>
      {/* <RegularText textAlign={labelAlign} fontSize="medium" color={AppColors.gray} textLang={label} /> */}
      <RegularText textAlign={labelAlign} color={AppColors.gray} textLang={label} />
      <SizedBox height="tiny" />
      {typeof value === 'string' || typeof value === 'number' ? (
        <RegularText fontSize="large" fontWeight="bold">
          {value}
        </RegularText>
      ) : (
        value
      )}
    </TouchableOpacity>
  );
};
